// extracted by css-extract-rspack-plugin
export default {"loading":"LoadingPage__loading--Iinc6"};